<template lang='pug'>
  footer
    footer-arch
    v-footer.white--text.footer-content.bionic-footer(color='primary' height='auto')
      v-container(fluid color='primary')
        v-row(justify='center' v-if='$vuetify.breakpoint.smAndDown')
          v-col.text-center
            v-img.footer-logo(src='../assets/bionicmetrics.png')
        v-row(justify='center').link-row
          v-col(cols='5' v-if='!$vuetify.breakpoint.smAndDown')
            v-img.footer-logo(src='../assets/bionicmetrics.png' width='30em')
          v-col(cols='10' sm='8' md='3').link-column
            div
              h2.headline Bionic Metrics
            div
              a(href='https://docs.bionicmetrics.com' target='_blank') Documentation
            div
              router-link(to='/') Home
            div
              router-link(to='terms') Terms
            div
              router-link(to='privacy') Privacy
          v-col(cols='10' sm='8' md='3').link-column
            div
              h2 Connect
            div
              router-link(to='/contact') Contact
            div
              router-link(to='/feedback') Feedback
            div
              a(href='https://www.linkedin.com/company/bionic-metrics/about/' target='_blank' rel="noreferrer") LinkedIn
        v-row.last-row(justify='center')
          v-col(cols='12' sm='8' md='6')
            subscribe(link bionic-id='2')
          span.bionic-copyright
            | &copy; 2019 Bionic Metrics, Inc.
</template>

<script>
import Subscribe from './Subscribe';
import FooterArch from './FooterArch';

export default {
  components: {
    Subscribe,
    FooterArch
  },
  name: 'Footer',
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer-content {
    margin-top: -6px;
    color: white;
  }

  .bionic-copyright {
    font-size: 12px;
    position: absolute;
    bottom: 5px;
    right: 10px;
  }

  .link-row {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .link-column {
    margin-top: 20px;
  }

  .last-row {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  footer .bionic-footer a {
    color: white;
  }

  footer .bionic-footer a:link {
    text-decoration: none;
  }

  footer .bionic-footer a:visited {
    text-decoration: none;
  }

  footer .bionic-footer a:hover {
    color: white;
    text-decoration: underline;
  }

  footer .bionic-footer a:active {
    color: white;
    text-decoration: underline;
  }
</style>
